

//CSS
import styles from './About.module.css';

const About = () => {
  return (
    <div className={styles.about}>
        <h2>Sobre DiTecBlog</h2>
        <p>O projeto feito, consiste em um blog no intuito de criar post utilizando React Js e o Firebase</p>
    </div>
  )
}

export default About